import introView from './introView.vue'
import firstView from './firstView.vue'
import secondView from './secondView.vue'
import thirdView from './thirdView.vue'
import fourthView from './fourthView.vue'
import fifthView from './fifthView.vue'
import sixthView from './sixthView.vue'
import seventhView from './seventhView.vue'
import findingsView from './findingsView.vue'

export default {
  introView,
  firstView,
  secondView,
  thirdView,
  fourthView,
  fifthView,
  sixthView,
  findingsView,
  seventhView
}